<script>
// TODO: Incorporate in DpListItem
  export default {
    name: "DpMobileCollapse",
    props: {
      headline: {type: String, default: ''}
    },
    data() {
      return {
        show: true
      };
    }
  }
</script>

<template>
  <div>
    <h3 @click="show = !show"><div :class="{'dp-mobile-collapse-headline-icon': true, 'active': show}"><i class="el-icon-arrow-right"/></div>
      <slot name="headline">{{headline}}</slot>
    </h3>
    <DpExpand>
      <div v-show="show">
        <slot></slot>
      </div>
    </DpExpand>
  </div>
</template>

<style scoped lang="scss">
  .dp-mobile-collapse-headline-icon {
    margin-inline-end: .25em;
    display: inline-block;
    transition-duration: 250ms;

    &.active {
      transform: rotate(90deg);
    }
  }
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
